export default "__VITE_ASSET__DWrdJa17__"